module.exports = __webpack_public_path__ + "img/icon_cumplimiento_rlv.7a761cd3.svg";